/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Faq_Q1Inputs */

const en_minifier_faq_q1 = /** @type {(inputs: Minifier_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much space can I save by minifying?`)
};

const ko_minifier_faq_q1 = /** @type {(inputs: Minifier_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축하면 얼마나 용량을 줄일 수 있나요?`)
};

const ja_minifier_faq_q1 = /** @type {(inputs: Minifier_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮でどのくらい容量を削減できますか？`)
};

/**
* | output |
* | --- |
* | "How much space can I save by minifying?" |
*
* @param {Minifier_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_faq_q1 = /** @type {((inputs?: Minifier_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_faq_q1(inputs)
	if (locale === "ko") return ko_minifier_faq_q1(inputs)
	return ja_minifier_faq_q1(inputs)
});